module.exports = __webpack_public_path__ + "static/img/14000082.3b8dadfe.png";